const getters = {
  getViewPortSize(state) {
    return state.viewPortSize;
  },
  getGlobalToaster(state) {
    return state.globalToaster;
  },
  getGlobalSpinnerShow(state) {
    return state.globalSpinnerShow;
  },
  getResizeWidth(state) {
    return state.resizeWidth;
  },
  getAgencies(state) {
    return state.agencies;
  },
  getCaseManagers(state) {
    return state.caseManagers;
  }
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js